import React, { useEffect } from 'react';
import { moduleHost } from '../../infrastructure/components/root-module-host';
import { EmailTemplatesVM } from './email-templates.viewmodel';
import { EmailTemplatesContext, connectEmailTemplatesVM } from './email-templates.contex';
import EmailTemplatesList from './_email-templates-list/email-templates-list';

interface IEmailTemplatesContainerProps {
    vm: EmailTemplatesVM;
}

const EmailTemplatesContainer = ({ vm }: IEmailTemplatesContainerProps) => {
    useEffect(() => {
        return () => {
            vm.willUnmount();
        };
    });

    return <EmailTemplatesList vm={vm} />;
};

const EmailTemplatesConnected = connectEmailTemplatesVM<IEmailTemplatesContainerProps>(EmailTemplatesContainer, vm => ({ vm: vm }));

export const EmailTemplates = moduleHost(EmailTemplatesVM, EmailTemplatesContext, EmailTemplatesConnected);